// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const StarIcon = (props?: any) => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M23 9.56a1 1 0 00-.87-.69l-6.6-.54-2.62-5.74A1 1 0 0012 2a1 1 0 00-.92.59L8.52 8.33l-6.6.54a1 1 0 00-.55 1.77l5 4.07-1.52 6.05a1 1 0 001.47 1.11L12 18.62l5.68 3.25a1 1 0 00.5.13 1 1 0 00.6-.2 1 1 0 00.37-1l-1.48-6.05 5-4.07A1 1 0 0023 9.56z" fill="currentColor"/></svg>'} />;

(StarIcon as any).displayName = 'StarIcon';

export default StarIcon;
